import React from 'react';
import { Card } from '@/components/ui/card';

export default function TermsPage() {

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 via-teal-50 to-cyan-50 p-4 pb-24">
      <div className="max-w-3xl mx-auto">
        <Card className="p-8 glass prose prose-teal max-w-none">
          <h1 className="text-4xl md:text-5xl font-extrabold text-teal-900 mb-6">Terms of Service</h1>
          <p className="text-gray-500">Last updated: February 19, 2026</p>

          <h2 className="text-2xl font-bold mt-8 mb-4 text-teal-800">1. Acceptance of Terms</h2>
          <p>By accessing or using 12challenges.com ("Service"), you agree to be bound by these Terms of Service ("Terms").</p>
          <p>If you do not agree to these Terms, do not use the Service.</p>

          <hr className="my-6" />

          <h2 className="text-2xl font-bold mt-8 mb-4 text-teal-800">2. Eligibility</h2>
          <p>You must be at least 13 years old to use the Service.</p>
          <p>By using the Service, you represent and warrant that you meet this requirement.</p>
          <p>If we discover that a user under 13 has created an account, we reserve the right to delete that account and associated data.</p>

          <hr className="my-6" />

          <h2 className="text-2xl font-bold mt-8 mb-4 text-teal-800">3. User Accounts</h2>
          <p>You are responsible for:</p>
          <ul className="list-disc pl-6 mb-4 space-y-1">
            <li>Maintaining the confidentiality of your account</li>
            <li>All activity that occurs under your account</li>
            <li>Providing accurate information</li>
          </ul>
          <p>You must not share your account with others.</p>
          <p>We reserve the right to suspend or terminate accounts at our discretion.</p>

          <hr className="my-6" />

          <h2 className="text-2xl font-bold mt-8 mb-4 text-teal-800">4. User Content</h2>
          <p>You retain ownership of the content you upload or create.</p>
          <p>By uploading content, you grant us permission to store, display, and process that content solely for the purpose of operating the Service.</p>
          <p>You agree not to upload content that:</p>
          <ul className="list-disc pl-6 mb-4 space-y-1">
            <li>violates any law</li>
            <li>infringes on others' rights</li>
            <li>is malicious or harmful</li>
          </ul>
          <p>We reserve the right to remove content at our discretion.</p>

          <hr className="my-6" />

          <h2 className="text-2xl font-bold mt-8 mb-4 text-teal-800">5. Account Deletion</h2>
          <p>You may delete your account at any time using the Service.</p>
          <p>Upon deletion, your personal data will be deleted in accordance with our Privacy Policy, except where retention is required for legitimate legal or security purposes.</p>

          <hr className="my-6" />

          <h2 className="text-2xl font-bold mt-8 mb-4 text-teal-800">6. Service Availability</h2>
          <p>The Service is provided on an "as is" and "as available" basis.</p>
          <p>We do not guarantee that the Service will be uninterrupted, secure, or error-free.</p>
          <p>We may modify, suspend, or discontinue the Service at any time without notice.</p>

          <hr className="my-6" />

          <h2 className="text-2xl font-bold mt-8 mb-4 text-teal-800">7. Limitation of Liability</h2>
          <p>To the maximum extent permitted by law, we shall not be liable for:</p>
          <ul className="list-disc pl-6 mb-4 space-y-1">
            <li>loss of data</li>
            <li>service interruptions</li>
            <li>damages arising from use or inability to use the Service</li>
          </ul>
          <p>Use of the Service is at your own risk.</p>

          <hr className="my-6" />

          <h2 className="text-2xl font-bold mt-8 mb-4 text-teal-800">8. Termination</h2>
          <p>We reserve the right to suspend or terminate your access to the Service at any time, for any reason, including violation of these Terms.</p>

          <hr className="my-6" />

          <h2 className="text-2xl font-bold mt-8 mb-4 text-teal-800">9. Privacy</h2>
          <p>Your use of the Service is also governed by our Privacy Policy.</p>
          <p>Please review it at: <a href="/privacy" className="text-teal-600 hover:underline">https://12challenges.com/privacy</a></p>

          <hr className="my-6" />

          <h2 className="text-2xl font-bold mt-8 mb-4 text-teal-800">10. Changes to These Terms</h2>
          <p>We may update these Terms from time to time.</p>
          <p>Changes will be posted on this page.</p>
          <p>Continued use of the Service constitutes acceptance of the updated Terms.</p>

          <hr className="my-6" />

          <h2 className="text-2xl font-bold mt-8 mb-4 text-teal-800">11. Governing Law</h2>
          <p>These Terms shall be governed by and interpreted in accordance with the laws of England and Wales.</p>

          <hr className="my-6" />

          <h2 className="text-2xl font-bold mt-8 mb-4 text-teal-800">12. Contact</h2>
          <p>If you have questions about these Terms, contact:</p>
          <p><a href="mailto:federicson7@gmail.com" className="text-teal-600 hover:underline">federicson7@gmail.com</a></p>
        </Card>
      </div>
    </div>
  );
}
